
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
import Vue from 'vue'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

@Component({
  components : {Doughnut}
})
export default class DoughnutChart extends Vue {
  @Prop({default: 'doughnut-chart'}) chartId!: string

  @Prop({default: 'label'}) datasetIdKey!: string

  @Prop({default: 250}) width!: number

  @Prop({default: 250}) height!: number

  @Prop({default: ''}) cssClasses!: string

  @Prop() styles!: unknown

  @Prop() plugins!: unknown []

  @Prop({required: true}) chartData!: unknown []

  @Prop() chartOptions!: unknown [] 
}

